/* tslint:disable */
/* eslint-disable */
/**
 * Notes API
 * API for managing notes with tags, mentions and attachments
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Minimal broker information
 * @export
 * @interface BrokerMinimalDto
 */
export interface BrokerMinimalDto {
    /**
     * Unique identifier of the broker
     * @type {string}
     * @memberof BrokerMinimalDto
     */
    id?: string;
    /**
     * Full name of the broker
     * @type {string}
     * @memberof BrokerMinimalDto
     */
    fullName?: string;
}

/**
 * Check if a given object implements the BrokerMinimalDto interface.
 */
export function instanceOfBrokerMinimalDto(value: object): value is BrokerMinimalDto {
    return true;
}

export function BrokerMinimalDtoFromJSON(json: any): BrokerMinimalDto {
    return BrokerMinimalDtoFromJSONTyped(json, false);
}

export function BrokerMinimalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrokerMinimalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
    };
}

export function BrokerMinimalDtoToJSON(json: any): BrokerMinimalDto {
    return BrokerMinimalDtoToJSONTyped(json, false);
}

export function BrokerMinimalDtoToJSONTyped(value?: BrokerMinimalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fullName': value['fullName'],
    };
}

